export default {
  title: 'Your drinks history in Louisiana',
  cocktail: 'cocktail',
  cocktails: 'cocktails',
};
